"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsOpened {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsOpened.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsOpened.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsOpened.attributeTypeMap = [
    {
        "name": "campaignId",
        "baseName": "campaignId",
        "type": "number"
    },
    {
        "name": "count",
        "baseName": "count",
        "type": "number"
    },
    {
        "name": "eventTime",
        "baseName": "eventTime",
        "type": "string"
    },
    {
        "name": "ip",
        "baseName": "ip",
        "type": "string"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsOpened = GetExtendedContactDetailsAllOfStatisticsOpened;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsOpened.js.map